export default __webpack_public_path__ + "static/media/Clodcrusher.9754d7d1.jpg";